import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/$siteId/connectors/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/settings/$siteId/connectors/installed",
      params: { siteId: params.siteId },
    });
  },
});
